var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ef"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ef"] = parcelRequire;
}

var $k8sLY = parcelRequire("k8sLY");
var $ieD7c = parcelRequire("ieD7c");
const $ef490c3938d2502d$var$logoLink = document.querySelector(".navigation__logo-link");
let $ef490c3938d2502d$var$allShowing = false;
let $ef490c3938d2502d$var$animating = false;
(0, $k8sLY.gsap).defaultEase = (0, $ieD7c.Power1).easeInOut;
$ef490c3938d2502d$var$logoLink.addEventListener("click", function(e) {
    e.preventDefault();
    if (!$ef490c3938d2502d$var$animating && !$ef490c3938d2502d$var$allShowing) $ef490c3938d2502d$var$showAll();
});
let $ef490c3938d2502d$var$navYOffset = 150;
if (window.innerWidth > 650) {
    $ef490c3938d2502d$var$navYOffset = 0;
    setTimeout(()=>{
        if (!$ef490c3938d2502d$var$animating && !$ef490c3938d2502d$var$allShowing) $ef490c3938d2502d$var$showAll();
    }, 2000);
} else setTimeout(()=>{
    if (!$ef490c3938d2502d$var$animating && !$ef490c3938d2502d$var$allShowing) $ef490c3938d2502d$var$showAll();
}, 0);
const $ef490c3938d2502d$var$time = (0, $k8sLY.gsap).timeline({
    onStart: ()=>{
        $ef490c3938d2502d$var$animating = true;
    },
    onComplete: ()=>{
        $ef490c3938d2502d$var$animating = false;
        $ef490c3938d2502d$var$allShowing = true;
    },
    onReverseComplete: ()=>{
        $ef490c3938d2502d$var$animating = false;
        $ef490c3938d2502d$var$allShowing = false;
    }
}).to(".navigation__home-logo", {
    scale: 1,
    duration: 2
}).to(".navigation", {
    y: $ef490c3938d2502d$var$navYOffset,
    duration: 2
}, "-=2").fromTo(".navigation__link--up", {
    opacity: 0
}, {
    opacity: 1,
    duration: 2,
    stagger: 0.2
}, "-=1").fromTo(".index__text", {
    opacity: 0,
    y: 75
}, {
    opacity: 1,
    y: 0,
    duration: 1,
    stagger: 0.5
}, "-=2").fromTo(".index__bottom-img", {
    opacity: 0
}, {
    opacity: 1,
    duration: 2
}, "-=3").pause();
function $ef490c3938d2502d$var$showAll() {
    $ef490c3938d2502d$var$time.play();
}


//# sourceMappingURL=index.03b6d85d.js.map
